import React, { createContext, useState, useCallback, useContext } from 'react';

import { Container, Loading } from './loadingStyles';

interface LoadingData {
  showLoading(data: boolean): void;
}

const LoadingContext = createContext<LoadingData>({} as LoadingData);

const LoadingProvider: React.FC = ({ children }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const showLoading = useCallback((isLoading) => {
    setIsLoading(isLoading);
  }, []);

  return (
    <LoadingContext.Provider value={{ showLoading }}>
      {isLoading && (
        <Container>
          <Loading />
        </Container>
      )}

      {children}
    </LoadingContext.Provider>
  );
};

function useLoading() {
  const context = useContext(LoadingContext);

  if (!context) {
    throw new Error('context must be used within an LoadingProvider');
  }

  return context;
}

export { LoadingProvider, useLoading };
